import styled, { css } from 'styled-components';

import { withLayoutProps } from '@/utils/withLayoutProps';

const StyledLink = styled.a`
  color: ${({ theme }) => theme.color.primary};
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
`;

const StyledOption = styled.div<{ $opened: boolean }>`
  position: relative;
  border: 1px solid ${(props) => (props.$opened ? props.theme.color.primary : props.theme.color.borderColor)};
  transition: border 0.2s ease-in-out;
  border-radius: ${(props) => props.theme.radius.md};
  height: fit-content;
  padding: 1rem 1.5rem;
  background-color: ${(props) => props.theme.color.offWhite};

  &:hover {
    border: 1px solid ${(props) => props.theme.color.primary};
    cursor: pointer;
  }
`;

const StyledOptionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;

  gap: 0.5rem;
`;

const StyledOptionContent = styled.div<{ $opened: boolean }>`
  max-height: ${(props) => (props.$opened ? '430px' : '0px')};
  overflow: hidden;
  transition: max-height 0.2s ease-in-out;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const StyledLogo = styled.img`
  height: 25px;
  width: auto;
`;

const StyledPageWidth = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const StyledIconWrapper = styled.div`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.primary};
  padding: 0.5rem;
`;

const StyledMobileView = withLayoutProps(styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`);

const StyledDesktopView = withLayoutProps(styled.div`
  display: block;
  flex: 1;

  @media (max-width: 768px) {
    display: none;
  }
`);

const StyledTableContainer = styled.div`
  max-width: calc(100vw - 2rem);
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const StyledTableHeader = styled.th`
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  background-color: ${({ theme }) => theme.color.offWhiteHover};
`;

const StyledTableRow = styled.tr<{ $isLast: boolean }>`
  border-bottom: ${({ $isLast, theme }) => ($isLast ? 'none' : `1px solid ${theme.color.borderColor}`)};
  transition: background-color 0.2s ease-in-out;
`;

const StyledTableCell = styled.td<{ $align?: 'center' }>`
  padding: 0.5rem 1rem;
  text-align: ${({ $align }) => $align || 'left'};
`;

const PAYMENT_STATUS_COLORS = {
  Paid: css`
    color: ${({ theme }) => theme.color.primary};
    background-color: ${({ theme }) => theme.color.primaryLight};
  `,
  Pending: css`
    color: ${({ theme }) => theme.color.tertiary};
    background-color: ${({ theme }) => theme.color.offWhiteHover};
  `,
  Open: css`
    color: ${({ theme }) => theme.color.bodyTextColor};
    background-color: ${({ theme }) => theme.color.bodyTextColorLight};
  `,
  Canceled: css`
    color: ${({ theme }) => theme.color.error};
    background-color: ${({ theme }) => theme.color.errorLight};
  `,
} as const;

type PaymentStatus = keyof typeof PAYMENT_STATUS_COLORS;

const StyledPaymentStatus = styled.div<{ $status: PaymentStatus }>`
  ${({ $status }) => PAYMENT_STATUS_COLORS[$status]};
  border-radius: ${({ theme }) => theme.radius.xl};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 35px;
  font-weight: 500;
  font-size: 14px;
`;

export {
  StyledLink,
  StyledOption,
  StyledOptionHeader,
  StyledOptionContent,
  StyledLogo,
  StyledPageWidth,
  StyledIconWrapper,
  StyledMobileView,
  StyledDesktopView,
  StyledTableContainer,
  StyledTable,
  StyledTableHeader,
  StyledTableRow,
  StyledTableCell,
  StyledPaymentStatus,
};
